import { IMPORTING } from "../data/BomStatus";
import { selectDataToInitializeBom } from "../selector/selectors";

import { 
  changeBomFile,
  checkBomInitialValues,
  replaceBomWorkbook,
  replaceBomParameters,
  updateBomBoardQtys,
  updateBomStatus,
  updateDataForImport,
  updateBomSelected,
  updateFileDirectory,
} from "../bomSlice"

export const initializeBom = (bom_header, workbook, file_name) => async (dispatch, getState) => {
  const {board_qtys, fabrication_slug} = selectDataToInitializeBom(getState())
  dispatch(checkBomInitialValues({product_slug: fabrication_slug, revision: "REV 1"}))
  dispatch(replaceBomParameters(bom_header))
  dispatch(replaceBomWorkbook(workbook))
  dispatch(changeBomFile(file_name))
  dispatch(updateBomBoardQtys(board_qtys))
  dispatch(updateDataForImport())
  dispatch(updateBomSelected(true))
  //dispatch(updateFileDirectory({}))
  dispatch(updateBomStatus(IMPORTING))
}